import { useFormStore } from '@/stores/form'
import client_lookups from '@/assets/json/clientLookups.json'

export default function (attachmentsList) {
  const formStore = useFormStore()

  const {
    salaryCertificateTransactionReason,
    attachmentTypes: { salaryCertificate }
  } = client_lookups

  const { transactionReasonId } = formStore.form.values

  if (!transactionReasonId || salaryCertificateTransactionReason.includes(transactionReasonId)) {
    return attachmentsList.filter((at) => at.id != salaryCertificate)
  }

  const salaryCertAttachment = attachmentsList.find((at) => at.id == salaryCertificate)
  attachmentsList = attachmentsList.filter((at) => at.id != salaryCertificate)
  if (salaryCertAttachment) {
    salaryCertAttachment.isMandatory = true
    attachmentsList.push(salaryCertAttachment)
  }

  return attachmentsList
}
